import { render, staticRenderFns } from "./BusinessPartnerTypeList.vue?vue&type=template&id=8f0e2c64&"
import script from "./BusinessPartnerTypeList.vue?vue&type=script&lang=js&"
export * from "./BusinessPartnerTypeList.vue?vue&type=script&lang=js&"
import style0 from "./BusinessPartnerTypeList.vue?vue&type=style&index=0&id=8f0e2c64&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports